import React from "react";
import { getFlagUrl } from "./Utils/getFlagUrl";

const KeirinMobile = ({ data, boldRows, rowRange, discipline }) => {
  const isSpacer = (row) => row.every((cell) => !cell || cell.trim() === "");

  const renderRiderRow = (row, index) => {
    const rowNumber = rowRange[0] + index + 1;
    const isBold = boldRows.includes(rowNumber);
    const rank = row[0] || "";
    const lastName = row[2] || "";
    const firstName = row[3] || "";
    const country = row[4] || "";
    const time = row[5] || "";

    return (
        
      <div key={index} className={`sqm-row ${isBold ? "bold-row" : ""}`}>
          <div className="mobile-keirin">
    {/* render blok */}
  </div>
        <div className="sqm-rank">{rank}</div>
        <div>
          <div className="sqm-last-name">{lastName}</div>
          <div className="sqm-first-name">{firstName}</div>
        </div>
        <div className="sqm-right">
  <div className="sqm-flag">
    <img src={getFlagUrl(country)} alt={country} className="flag-icon" />
  </div>
  <div className="sqm-time">{time}</div>
</div>

      </div>
      
    );
  };
  
  
  const renderHeaderRow = (text, key) => (
    <div className="ssm-final-header" key={`header-${key}`}>
      <div className="final-header-cell">{text}</div>
    </div>
  );

  return (
    <div className="mobile-sprint-qualification">
      {(() => {
        const rendered = [];

        for (let i = 0; i < data.length; i++) {
          const row = data[i];
          if (isSpacer(row)) continue;

          // Header row from sheet like "Heat 1", "Repechage 2", etc.
          const isLabelRow = row[0] && row[0].toLowerCase().match(/^(heat|repechage|final)/);
          if (isLabelRow) {
            rendered.push(renderHeaderRow(row[0], i));
            continue;
          }

          // Skip any header-type data rows
          const isHeaderRow = row[0]?.toLowerCase() === "rnk" && row[1]?.toLowerCase() === "bib";
          if (isHeaderRow) continue;

          rendered.push(renderRiderRow(row, i));
        }

        return rendered;
      })()}
    </div>
  );
};

export default KeirinMobile;
